var render = function render(){var _vm=this,_c=_vm._self._c;return _c('service-area-table',{attrs:{"items":_vm.getMyList(_vm.username),"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }